import { jsx as _jsx } from "preact/jsx-runtime";
import { useContext } from 'preact/compat';
import { BasketUpsellSimpleFormCTX } from '@basket/types/BasketUpsellSimpleFormContext';
import { FormProvider, useForm, } from 'react-hook-form';
import { miscProductsSchema } from '@widgets/MiscProducts/validation/schema';
import { yupResolver } from '@hookform/resolvers/yup';
import MiscForm from '@widgets/UpsellModal/components/MiscForm';
import { Wrapper } from './styled';
function SimpleForm({ onComplete }) {
    const { item } = useContext(BasketUpsellSimpleFormCTX);
    const form = useForm({
        mode: 'onChange',
        resolver: yupResolver(miscProductsSchema),
        defaultValues: {
            MiscellaneousId: item.MiscellaneousId,
            PriceBands: item.PriceBands.map((band, idx) => ({
                PriceBandId: band.PriceBandId,
                Units: 0,
            })),
        },
    });
    return (_jsx(Wrapper, { children: _jsx(FormProvider, { ...form, children: _jsx(MiscForm, { postSubmit: () => { onComplete(); }, options: BasketUpsellSimpleFormCTX, shouldSubmit: true }) }) }));
}
export default SimpleForm;
